import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { IApiDependencySegment, catchApiError } from '@cbridge-packages/api-admin';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { selectedTenantSelector } from '@cbridge-packages/tenant';
import { UserAction } from '../user.action';
import { UserTranslator } from '../user.translator';

type IState =
  & IGetSelectorStateType<typeof selectedTenantSelector>;

type IDependencies = IApiDependencySegment;

export const createUserEpic: IEpic<IState, IDependencies> = (action$, state$, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(UserAction.create),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { user, resolve, reject } = payload;

    const tenantId = selectedTenantSelector(state);

    return dependencies.api.createUser({
      tenantId,
      ...UserTranslator.toApi(user),
    }).pipe(
      mergeMap((response) => {
        const { userId } = response;

        resolve?.(userId);

        return [
          UserAction.createDone({ userId }),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);

        return [
          UserAction.createFailed(),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
